import React from 'react'
import ApiRequest from 'EurestoApi/ApiRequest'
import Datagrid from 'EurestoComponents/Datagrid/index'

import Grid from '@material-ui/core/Grid'

import moment from 'moment'
import Utils from 'EurestoFonction/Utils'

const project = require('EurestoConfig/project.config')
moment.locale('fr')

export default class Financiers extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      client_id: this.props.client_id,
      renderGrid: this.props.view,
      keyFacture: Utils.getRandomNumber()
    }

  }

  getFactureClient = async () => {
    const result = await ApiRequest(project.api + 'facturation', {
      action: 'list',
      requete: 'facture',
      contact_id: this.state.client_id
    }, { showAlertError: false })
    if (result.results !== undefined) {
      return {
        facture: result,
        viewGridFacture: 1
      }
    }
  }

  async componentDidMount() {
    const facture = await this.getFactureClient()
    this.setState({
      ...facture,
    })
  }

  loadGridFacture = () => {
    const columnsFichier = [
      { Header: 'id', accessor: 'id', id: 'id', show: false },
      { Header: 'contact_id', accessor: 'contact_id', id: 'contact_id', show: false },
      { Header: 'client_id', accessor: 'client_id', id: 'client_id', show: false },
      { Header: 'pdv_id', accessor: 'pdv_id', id: 'pdv_id', show: false },
      /*{ Header: 'Année', accessor: 'date_facture' },*/
      {
        Header: 'Date', accessor: 'date_facture',
        Cell: (row) => {
          return <span>{moment(row.original.date_facture).format('DD/MM/YY HH:mm:ss')}</span>
        }
      },
      { Header: 'Numéro Facture', accessor: 'num_facture' },
      { Header: 'Point de Vente', accessor: 'libelle' },
      {
        Header: 'Montant HT', accessor: 'montant_ht',
        Cell: (row) => {
          const val = row.original.montant_ht && this.arrondiMillieme(row.original.montant_ht) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      {
        Header: 'Montant TVA', accessor: 'montant_tva',
        Cell: (row) => {
          const val = row.original.montant_tva && this.arrondiMillieme(row.original.montant_tva) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      {
        Header: 'Montant TTC', accessor: 'montant_ttc',
        Cell: (row) => {
          const val = row.original.montant_ttc && this.arrondiMillieme(row.original.montant_ttc) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      /*{ Header: 'Service N°', accessor: 'numero_service' },*/
      {
        Header: 'Service HT', accessor: 'montant_service_ht',
        Cell: (row) => {
          const val = row.original.montant_service_ht && this.arrondiMillieme(row.original.montant_service_ht) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      {
        Header: 'Service TVA', accessor: 'montant_service_tva',
        Cell: (row) => {
          const val = row.original.montant_service_tva && this.arrondiMillieme(row.original.montant_service_tva) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      {
        Header: 'Remise', accessor: 'remise',
        Cell: (row) => {
          const val = row.original.remise && this.arrondiMillieme(row.original.remise) || 0
          return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
            alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
        }
      },
      /*{
        Header: 'Pax', accessor: 'libelle_pax_free',
        Cell: (row) => {
          return <span>{row.original.libelle_pax_free && (row.original.libelle_pax_free + ' (' + row.original.quantite_pax_free + ')')}</span>
        }
      },*/
      /*{ Header: 'Qté Pax Free', accessor: 'quantite_pax_free' },*/

    ]
    return <Datagrid data={this.state.facture || []} columnsName={columnsFichier}
      onClick={() => {
      }} showPaginationBottom={true} type="client"
      isSubComponent={true}
      filterable={false}
      filtered={false}
      gridSubComponent={this.dataGridLigneFacture}
    />
  }
  dataGridLigneFacture = (row) => {
    const columnsLigneFacture = [
      {
        Header: 'Ligne Facture',
        columns: [
          { Header: 'facture_ligne_id', accessor: 'id', show: false },
          { Header: 'facture_id', accessor: 'facture_id', show: false },
          { Header: 'produit_id', accessor: 'produit_id', show: false },
          { Header: 'Libelle', accessor: 'libelle', minWidth: 150 },
          { Header: 'Quantité', accessor: 'quantite' },
          {
            Header: 'Prix HT', accessor: 'montant_ht',
            Cell: (row) => {
              const val = row.original.montant_ht && this.arrondiMillieme(row.original.montant_ht) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
          {
            Header: 'Prix TVA', accessor: 'montant_tva',
            Cell: (row) => {
              const val = row.original.montant_tva && this.arrondiMillieme(row.original.montant_tva) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
          {
            Header: 'Prix TTC', accessor: 'montant_ttc',
            Cell: (row) => {
              const val = row.original.montant_ttc && this.arrondiMillieme(row.original.montant_ttc) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
          {
            Header: 'Service TTC', accessor: 'montant_service_ht',
            Cell: (row) => {
              const val = row.original.montant_service_ht && this.arrondiMillieme(row.original.montant_service_ht) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
          {
            Header: 'Offert', accessor: 'com_offert',
            Cell: (row) => {
              const val = row.original.com_offert && this.arrondiMillieme(row.original.com_offert) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
        ]
      }
    ]

    const columnsModeEncaissement = [
      {
        Header: 'Mode Encaissement',
        columns: [
          { Header: 'mode_encaissement_id', accessor: 'id', show: false },
          { Header: 'facture_id', accessor: 'facture_id', show: false },
          { Header: 'Libelle', accessor: 'libelle' },
          {
            Header: 'Montant', accessor: 'montant_unitaire_encaissement',
            Cell: (row) => {
              const val = row.original.montant_unitaire_encaissement && this.arrondiMillieme(row.original.montant_unitaire_encaissement) || 0
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{val + (val.toString().indexOf('.') === -1 && '.00' || '')}</Grid>
            }
          },
        ]
      }
    ]

    const columnsPax = [
      {
        Header: 'Pax',
        columns: [
          { Header: 'pax_id', accessor: 'pax_id', show: false },
          { Header: 'facture_id', accessor: 'facture_id', show: false },
          { Header: 'type_marque_id', accessor: 'type_marque_id', show: false },
          { Header: 'Libelle', accessor: 'libelle' },
          { Header: 'Quantité', accessor: 'Quantité' },
        ]
      }
    ]
    const rowDataLigneFacture = row.original['ligne_facture'][0]
    const rowDataModeEncaissement = row.original['mode_encaissement'][0]
    const rowDataPax = row.original['pax'][0]
    const actions = {}
    return (
      <Grid container>
        <Datagrid
          filterable={false}
          filtered={false} columnsName={columnsLigneFacture} data={rowDataLigneFacture} type="client" />
        <Datagrid
          filterable={false}
          filtered={false} columnsName={columnsModeEncaissement} data={rowDataModeEncaissement} type="client" />
        <Datagrid
          filterable={false}
          filtered={false}
          columnsName={columnsPax} data={rowDataPax} type="client" />
      </Grid>
    )

  }

  viewFacture = (id) => {

  }

  loadGridStats = () => {
    const tabStatsAnnee = []
    this.state.facture.results.map((dataF, index) => {
      let anneeFact = moment(dataF.date_facture).format('YYYY')
      let pdvFact = dataF.pdv_id
      if (tabStatsAnnee[anneeFact + pdvFact] !== undefined) {
        tabStatsAnnee[anneeFact + pdvFact] = {
          libelle: dataF.libelle,
          pdv_id: pdvFact,
          montant_ht: tabStatsAnnee[anneeFact + pdvFact] !== undefined ? (tabStatsAnnee[anneeFact + pdvFact].montant_ht + dataF.montant_ht) : (0 + dataF.montant_ht),
          montant_ttc: tabStatsAnnee[anneeFact + pdvFact] !== undefined ? (tabStatsAnnee[anneeFact + pdvFact].montant_ttc + dataF.montant_ttc) : (0 + dataF.montant_ttc),
          nb: tabStatsAnnee[anneeFact + pdvFact] !== undefined ? (tabStatsAnnee[anneeFact + pdvFact].nb + 1) : 1,
          annee: anneeFact
        }
      } else {
        tabStatsAnnee[anneeFact + pdvFact] = {
          libelle: dataF.libelle,
          pdv_id: pdvFact,
          montant_ht: (0 + dataF.montant_ht),
          montant_ttc: (0 + dataF.montant_ttc),
          nb: 1,
          annee: anneeFact
        }
      }
    })

    const actions = {}
    const tabStats = []
    let i = 0
    Object.keys(tabStatsAnnee).map(key => {
      tabStats[i] = tabStatsAnnee[key]

      i++
    })

    const totalTTC = this.arrondiMillieme(_.sum(_.map(tabStats, d => d.montant_ttc)))
    const totalVisite = _.sum(_.map(tabStats, d => d.nb))
    const columnsStats = [
      {
        Header: 'Chiffre Affaire Année/Point de vente',
        columns: [
          { Header: 'pdv_id', accessor: 'pdv_id', show: false },
          {
            Header: 'Année', accessor: 'annee'
          },
          {
            Header: 'Point de vente', accessor: 'libelle',
            Footer: (<strong>Total</strong>)
          },
          {
            Header: 'Visite', accessor: 'nb',
            Footer: (<span style={{ textAlign: 'right' }}>{totalVisite}</span>)
          },
          {
            Header: 'Montant TTC',
            accessor: 'montant_ttc',
            Cell: (row) => {
              return <Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
                alignItems={'center'}>{row.original.montant_ttc + (row.original.montant_ttc.toString().indexOf(',') === -1 && ',00' || '')}</Grid>
            },
            Footer: (<Grid container spacing={0} style={{ margin: 0, padding: 0, height: '100%' }} justify={'flex-end'}
              alignItems={'center'}>{totalTTC + (totalTTC.toString().indexOf(',') === -1 && ',00' || '')}</Grid>)
          },
        ]
      }
    ]
    return <Datagrid
      filterable={false}
      filtered={false}
      columnsName={columnsStats} data={tabStats} type="client" rowAction={actions} />

  }

  arrondiMillieme = (val) => {
    return Math.round(val * 1000) / 1000
  }

  render() {
    if (this.state.renderGrid) {
      return (<Grid container key={this.state.keyFacture}>
        {this.state.facture !== undefined && this.loadGridStats()}
      </Grid>)
    } else {
      return (<Grid container>
        {this.state.viewGridFacture && this.loadGridFacture()}
      </Grid>)
    }

  }

}



// WEBPACK FOOTER //
// ./app/App/Module/CRM/Component/Financiers/Financiers.js